import { fnLocalizeFilter } from "../../../../services/localize.service";
import * as React from "react";
import { useGlobalContext } from "../../../../services/context.service";
import ComboBox from "../../../UI/Input/ComboBox";
import { Grid } from "@mui/material";
import { IHolders } from "../../../../services/response.interface";

interface ISelectClient {
	holders: IHolders[];
	selectHolderId: number;

	onSelectClient ( holderId: number ): void;
}


export default function SelectClient ( { holders, selectHolderId, onSelectClient }: ISelectClient ) {
	const { locale } = useGlobalContext();


	const handleChangeHolder = ( holderId: any ) => {
		onSelectClient( holderId )
	};

	return (

		<Grid item xs={ 12 } md={ 2 }>
			{
				<ComboBox
					textStyle={ { fontWeight: '700' } }
					data={ holders }
					fieldLabelOption={ 'name' }
					label={ fnLocalizeFilter( locale, '_lang.module.clientList.titlePage' ) }
					callbackType={ 'onlyId' }
					fnOnChange={ handleChangeHolder }
					defaultValue={ selectHolderId }
				/>
			}
		</Grid>

		/*
		<CustomTable
			rows={ rows.arr }
			columns={ columns }
			isSimple
			isLoading={ isLoading }
			labelEmptyRows={ fnLocalizeFilter( locale, '_lang.module.common.table.emptyRows' ) }
			onClick={ onSelectRow }
		/>
		*/


	)
}
